


import { BrandingStyle, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from "components/custom-ui/CustomAccordion";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import IconToggle from "components/shared/views/IconToggle";
import InfoAlertView from "components/shared/views/InfoAlertView";
import { PrimaryButton, SecondaryButton, UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { SVGAsset } from "res";
import TASPositivePayViewChecksNoResultsContent from "../TASPositivePayViewChecksNoResultsContent";
import TASPositivePayViewChecksMobileView from "../TASPositivePayViewChecksMobileView";

/**
 * @function TASPositivePayViewChecksMobileFormView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay View Checks mobile content view.
 */
export default function TASPositivePayViewChecksMobileFormView() {
    const { data, ui, onChange, onClear, onSearch, onSearchMobileButtonClick } = useStateManager();
    const checkForms = data.checkForms;
    const hasSearchResults = data.checkForms.length > 0;
    const search = data.search;
    const accountItems = search.accounts.reduce((acc, item) => {
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.id }>{ `${ item.nickname } ${ item.number }` }</CustomSelectItem>
        )
        return acc;
    }, []);

    const statusItems = search.statuses.reduce((acc, item) => {
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.value }>{ item.label }</CustomSelectItem>
        );
        return acc;
    }, []);

    const navigate = useRoute();
    const onAddChecks = evt => {
        navigate("/tasPositivePayAddChecks");
    };

    return (
        <div className="show-on-mobile tas-positive-pay-view-checks-mobile-view-container">
            { ui.search.didSaveChanges.isActive && 
            <div className="flex-container flex-horizontal successfully-saved-changes-container">
                <div className="flex-width"></div>
                <div className="set-width success-alert">
                    <InfoAlertView text="The change(s) have been successfully saved." className="checkmark-style" icon={ <SVGAsset id="CircleCheckmarkIcon" className="checkmark-icon" /> } />
                </div>
                <div className="flex-width"></div>
            </div>
            }
            <div className="flex-container align-top">
                
                <CustomAccordion isOpen={ ui.search.mobile.isActive }>
                    <div className="flex-container flex-horizontal align-center">
                        <div className="flex-width">
                            <CustomAccordionToggle className={ "search" } onClick={ onSearchMobileButtonClick }>
                                <IconToggle icon="MagnifyingGlassIcon" text="Search" dataPoint="Search"/>
                            </CustomAccordionToggle>
                        </div>
                    </div>
                    <CustomAccordionContent className="flex-container flex-vertical search-custom-accordion">
                        <CustomAccordionToggle className="flex-container flex-width close-accordion" onClick={ onSearchMobileButtonClick }>
                            <BrandingStyle className="flex-width" style={{"color" : "search_text_abi22"} } element={<p >SEARCH</p>}/>
                            <SVGAsset className="icon set-width" id="CloseX" data-point="CloseButton" />
                        </CustomAccordionToggle>
                        <FormContainer className="small-form-width">
                            <FormRowView text="Account">
                                <CustomSelect active={ ui.search.account.isActive } value={ search.account.id } onChange={ onChange("account") }>
                                    { accountItems }
                                </CustomSelect>
                            </FormRowView>
                            <FormRowView text="Payee">
                                <UITextInput value={ search.payee } onChange={ onChange("payee") } />
                            </FormRowView>
                            <FormRowView text="Status">
                                <CustomSelect value={ search.status } active={ ui.search.status.isActive } onChange={ onChange("status") }>
                                    { statusItems }
                                </CustomSelect>
                            </FormRowView>
                            <FormRowView text="Check Number From">
                                <UITextInput value={ search.checkNumberFrom } onChange={ onChange("checkNumberFrom") } />
                            </FormRowView>
                            <FormRowView text="Check Number To">
                                <UITextInput value={ search.checkNumberTo } onChange={ onChange("checkNumberTo") } />
                            </FormRowView>
                            <div className="flex-container flex-horizontal">
                                <FormRowView className="first-horizontal-row-view issued-date-from" text="Issued Date From">
                                    <DateSelect value={ search.issuedDateFrom } active={ ui.search.issuedDateFrom.isActive } 
                                    enablePast={ true } onChange={ onChange("issuedDateFrom") }  />
                                </FormRowView>
                                <FormRowView className="issued-date-to" text="Issued Date To">
                                    <DateSelect value={ search.issuedDateTo } active={ ui.search.issuedDateTo.isActive }
                                    enablePast={ true } onChange={ onChange("issuedDateTo") } />
                                </FormRowView>
                            </div>
                            <div className="flex-container flex-horizontal">
                                <FormRowView className="first-horizontal-row-view" text="Minimum Amount">
                                    <UIAmountInput className="amount-field" value={ search.minimumAmount } showClearButton={ false } onChange={ onChange("minimumAmount") } />
                                </FormRowView>
                                <FormRowView text="Maximum Amount">
                                    <UIAmountInput className="amount-field" value={ search.maximumAmount } showClearButton={ false } onChange={ onChange("maximumAmount") } />
                                </FormRowView>
                            </div>
                            <div className="flex-container flex-horizontal button-container">
                                <SecondaryButton className="set-width" text="Clear" onClick={ onClear } />
                                <PrimaryButton className="set-width" text="Search" onClick={ onSearch } />
                            </div>
                        </FormContainer>
                    </CustomAccordionContent>
                </CustomAccordion>
            </div>
            { !ui.search.didSearch.isActive && 
            <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                <div className="set-width curfew-alert">
                    <InfoAlertView text="Please use search to find checks." icon={ <SVGAsset id="InfoIcon" /> } />
                </div>
            </div>
            }
            { ui.search.didSearch.isActive && 
            <div className="flex-container flex-vertical no-results-content">
                <div className="search-result-message row">{`Search Result (${ checkForms.length })`}</div>
            </div>
                }
            {/* Statically shown until checks are added to the model. */}
            { ui.search.didSearch.isActive && !hasSearchResults &&
            <TASPositivePayViewChecksNoResultsContent onAddChecks={ onAddChecks } />
            }
            { ui.search.didSearch.isActive && hasSearchResults && 
            <TASPositivePayViewChecksMobileView/>
            }
        </div>
    )
}